var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-not-found-comp"},[_c('img',{staticClass:"image",attrs:{"src":require("./images/img_page_not_found@2x.png"),"width":_vm.$px(156),"height":_vm.$px(156),"alt":""}}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }